/* LUS · Cart: quantity and remove without leaving the page.
   Uses /cart/change.js with the Section Rendering API, so the totals come back
   formatted by Liquid instead of being guessed in JavaScript. */
(function () {
  'use strict';

  function root() { return document.querySelector('.lcart'); }

  function sectionId() {
    var el = root();
    return el ? el.dataset.sectionId : null;
  }

  function setCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (el) {
      el.textContent = n;
      el.hidden = n < 1;
      if (n > 0) el.removeAttribute('hidden');
    });
  }

  function change(line, quantity) {
    var id = sectionId();
    var el = root();
    if (!id || !el) return;
    el.classList.add('busy');

    fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/change.js'
      : '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity, sections: id, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data && data.sections && data.sections[id];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('.lcart');
          if (fresh) el.replaceWith(fresh);
        }
        if (typeof data.item_count === 'number') setCount(data.item_count);
        bind();
      })
      .catch(function () {
        // network trouble: fall back to a normal page load rather than lying
        location.reload();
      });
  }

  function bind() {
    var el = root();
    if (!el || el.dataset.lusBound === '1') return;
    el.dataset.lusBound = '1';

    el.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-line]');
      if (!btn) return;
      e.preventDefault();
      var line = parseInt(btn.dataset.line, 10);
      var qty = parseInt(btn.dataset.qty, 10);
      if (!line || isNaN(qty)) return;
      change(line, qty);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bind);
  else bind();
})();
